import axios from './axios'
import qs from 'qs';
let userBastUrl = '/api/supplier/';
/**
 *
 *
 */
export default {
  addOrUpdate(data) {
    return axios.post(userBastUrl + 'addOrUpdate', qs.stringify(data));
  },
  list(data) {
    return axios.get(userBastUrl + 'list', {
      params: data
    });
  },
  listStatistics(data) {
    return axios.get(userBastUrl + 'listStatistics', {
      params: data
    });
  },
  delete(data) {
    return axios.get(userBastUrl + 'delete', {
      params: data
    });
  },
  listStatisticsGroupByMaterialId(data) {
    return axios.get(userBastUrl + 'listStatisticsGroupByMaterialId', {
      params: data
    });
  },
  editSupplierProductRelation(data) {
    return axios.get(userBastUrl + 'editSupplierProductRelation', {
      params: data
    });
  },
  statisticsDetail(data) {
    return axios.get(userBastUrl + 'statisticsDetail', {
      params: data
    });
  },
  editSupplierDetail(data) {
    return axios.post(userBastUrl + 'editSupplierDetail', qs.stringify(data));
  },
  listSupplierDetail(data) {
    return axios.get(userBastUrl + 'listSupplierDetail', {
      params: data
    });
  },
}
